import Notification from '@/modules/auth/models/Notification'

export default {
  namespaced: true,
  actions: {
    async getAll({ _dispatch }, type) {
      try {
        if (type == 'users') type = 'students'
        const notifications = await this._vm.$axios.get(
          `/api/${type}/notifications`
        )
        Notification.insert({ data: notifications }, { root: true })
        return notifications
      } catch (error) {
        throw error
      }
    },
    async readSingle({ _dispatch }, { payload }) {
      console.log({ payload })
      try {
        const notifications = await this._vm.$axios.post(
          `/api/${payload.type}/read-notification/${payload.id}`
        )

        Notification.insertOrUpdate({ data: notifications }, { root: true })
        return notifications
      } catch (error) {
        throw error
      }
    },
    async readAll({ _dispatch }, type) {
      try {
        const notifications = await this._vm.$axios.patch(
          `/api/${type}/notifications`
        )
        Notification.insertOrUpdate({ data: notifications }, { root: true })
        return notifications
      } catch (error) {
        throw error
      }
    }
  }
}
